// tslint:disable:max-line-length
import * as React from 'react';

export const heart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12">
    <path fill="none" fillRule="evenodd" stroke="#E84260" strokeWidth="2" d="M6.912 10.945v-.006h.057a.382.382 0 0 0-.057.006zm-.198.097a.34.34 0 0 0-.005.004l.005-.004zm.274-.266l5.183-5.016a2.786 2.786 0 0 0 .005-3.964c-1.13-1.091-2.977-1.091-4.107 0l-.03.027-1.084.967-.667-.645-.362-.349C4.796.705 2.95.705 1.833 1.783a2.786 2.786 0 0 0-.011 3.965l5.166 5.028z" opacity=".9"/>
  </svg>
);

// tslint:enable:max-line-length
